import { Action } from '@ngrx/store';
import { Eula } from '@polaris-customerweb/sharedcomponents.shared';

export const EulaAction = {
    setEula: '[eula] set eula',
};

export class SetEula implements Action {
    type = EulaAction.setEula;
    constructor(public eula: Eula) {}
}
